import { render, staticRenderFns } from "./UrgentServiceLayout.vue?vue&type=template&id=f9bc38ec&"
import script from "./UrgentServiceLayout.vue?vue&type=script&lang=js&"
export * from "./UrgentServiceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports